import '@app/polyfills';
import 'normalize.css';
import '@app/styles/index.scss';
import 'moment/dist/locale/ru';

import { RouterProvider, createRouter } from '@tanstack/react-router';
import moment from 'moment';
import ReactDOM from 'react-dom/client';

import { logger } from '@app/logger';
import { onRouterCatch, reportTmaTransportOnce } from '@app/logger/crashReport';

import { getStartParam } from '@common/utils/startParam';

import { routeTree } from './routeTree.gen';

moment.locale('ru');

//@ts-expect-error TelegramGameProxy
if (typeof window.TelegramGameProxy === 'undefined') {
  //@ts-expect-error TelegramGameProxy
  window.TelegramGameProxy = { receiveEvent: () => {} };
}

const router = createRouter({
  routeTree,
  scrollRestoration: true,
  scrollToTopSelectors: ['#root'],
  // Central crash handler: runs from the router's CatchBoundary
  // componentDidCatch — ONCE per caught error (unlike anything placed in
  // the errorComponent, which re-runs with its renders), and it is the only
  // place that receives the React componentStack. See createOnCatch in
  // crashReporter.ts for what it reports where.
  defaultOnCatch: onRouterCatch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

logger.init();

// Ensure referral code is captured before any component effects run
try {
  const urlParam =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('tgWebAppStartParam')
      : null;

  const raw = getStartParam() || urlParam;
  const firstStored =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem('referral_code_first')
      : null;

  const isRef = typeof raw === 'string' && raw.startsWith('r_');

  let referral = 'organic';
  if (isRef) {
    const code = raw.slice(2);
    if (code && code.length > 0) referral = code;
  } else if (!raw && firstStored) {
    referral = firstStored;
  }

  if (typeof sessionStorage !== 'undefined') {
    // Only store real referral codes; tokens/campaign markers resolve on server
    sessionStorage.setItem('referral_code', referral);
  }
  if (isRef && !firstStored && typeof localStorage !== 'undefined') {
    // Persist first-touch referral code only
    const code = raw.slice(2);
    if (code && code.length > 0) {
      localStorage.setItem('referral_code_first', code);
    }
  }
} catch (_e) {
  // ignore storage or environment errors
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RouterProvider router={router} />,
);

// Measures how many sessions were LAUNCHED from Telegram yet have no host
// transport — the population that used to white-screen and is now silently
// degraded. See createTransportProbe (crashReporter.ts) for the gate and for
// the two blind spots that make this a floor rather than a census.
//
// Deferred rather than run at render because the client can inject its bridge
// slightly after first paint, and a false positive is worse than a late one.
// The cost is that sessions bouncing inside the delay go uncounted.
setTimeout(reportTmaTransportOnce, 3000);
